import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="iban-validator"
export default class extends Controller {
  static targets = ["input", "error"];

  connect() {
  }

  validate() {
    const iban = this.inputTarget.value.replace(/\s+/g, ''); // Remove spaces
    const isValid = this.validGermanIBAN(iban);
    if (!isValid) {
      if (this.hasErrorTarget) {
        this.errorTarget.textContent = "Bitte gültige deutsche IBAN eingeben. ";
      }
      this.inputTarget.classList.add('is-danger');
    } else {
      if (this.hasErrorTarget) {
        this.errorTarget.textContent = "";
      }
      this.inputTarget.classList.remove('is-danger');
    }
  }

  validGermanIBAN(iban) {
    const regex = /^DE\d{20}$/;
    return regex.test(iban) || iban == '';
  }
}
